import * as React from 'react';

const SelectCustomerIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="240"
      height="140"
      viewBox="0 0 480 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="select-customer-illustration"
    >
      <path
        d="M258.404 237.807C258.404 247.372 250.661 255.125 241.109 255.125H155.932C146.381 255.125 138.638 247.372 138.637 237.807V18.3187C138.638 8.75391 146.381 1.00018 155.932 1H166.265L230.046 1H241.109C250.661 1.00018 258.404 8.75391 258.404 18.3187V237.807Z"
        fill="#F7F7F7"
      />
      <path
        d="M160.472 21.3572C156.297 21.3572 152.438 23.588 150.35 27.2093C148.262 30.8306 148.262 35.2922 150.35 38.9136C152.438 42.5349 156.297 44.7657 160.472 44.7657H160.472C166.928 44.7657 172.161 39.5255 172.161 33.0615C172.161 26.5974 166.928 21.3572 160.472 21.3572V21.3572Z"
        fill="#E6E8E9"
      />
      <path
        d="M245.335 42.9371H183.972C182.358 42.9371 181.05 41.6271 181.05 40.011C181.05 38.395 182.358 37.085 183.972 37.085H245.335C246.948 37.085 248.257 38.395 248.257 40.011C248.257 41.6271 246.948 42.9371 245.335 42.9371Z"
        fill="#E6E8E9"
      />
      <path
        d="M203.331 30.5011H183.972C182.358 30.5011 181.05 29.191 181.05 27.575C181.05 25.959 182.358 24.6489 183.972 24.6489H203.331C204.944 24.6489 206.253 25.959 206.253 27.575C206.253 29.191 204.944 30.5011 203.331 30.5011Z"
        fill="#E6E8E9"
      />
      <path
        d="M160.472 70.3689C156.297 70.3689 152.438 72.5997 150.35 76.221C148.262 79.8423 148.262 84.3039 150.35 87.9253C152.438 91.5466 156.297 93.7774 160.472 93.7774H160.472C166.928 93.7774 172.161 88.5373 172.161 82.0732C172.161 75.6091 166.928 70.3689 160.472 70.3689Z"
        fill="#E6E8E9"
      />
      <path
        d="M245.335 91.9486H183.972C182.358 91.9486 181.05 90.6385 181.05 89.0225C181.05 87.4065 182.358 86.0964 183.972 86.0964H245.335C246.948 86.0964 248.257 87.4065 248.257 89.0225C248.257 90.6385 246.948 91.9486 245.335 91.9486Z"
        fill="#E6E8E9"
      />
      <path
        d="M203.331 79.5128H183.972C182.358 79.5128 181.05 78.2027 181.05 76.5867C181.05 74.9707 182.358 73.6606 183.972 73.6606H203.331C204.944 73.6606 206.253 74.9707 206.253 76.5867C206.253 78.2027 204.944 79.5128 203.331 79.5128Z"
        fill="#E6E8E9"
      />
      <path
        d="M160.472 168.392C154.017 168.392 148.784 173.632 148.784 180.096C148.784 186.56 154.017 191.801 160.472 191.801H160.472C166.928 191.801 172.161 186.56 172.161 180.096C172.161 173.632 166.928 168.392 160.472 168.392V168.392Z"
        fill="#E6E8E9"
      />
      <path
        d="M245.335 189.972H183.972C182.358 189.972 181.05 188.662 181.05 187.046C181.05 185.43 182.358 184.12 183.972 184.12H245.335C246.948 184.12 248.257 185.43 248.257 187.046C248.257 188.662 246.948 189.972 245.335 189.972Z"
        fill="#E6E8E9"
      />
      <path
        d="M203.331 177.536H183.972C182.358 177.536 181.05 176.226 181.05 174.61C181.05 172.994 182.358 171.684 183.972 171.684H203.331C204.944 171.684 206.253 172.994 206.253 174.61C206.253 176.226 204.944 177.536 203.331 177.536Z"
        fill="#E6E8E9"
      />
      <path
        d="M160.472 217.404C156.297 217.404 152.438 219.634 150.35 223.256C148.262 226.877 148.262 231.339 150.35 234.96C152.438 238.581 156.297 240.812 160.472 240.812H160.472C166.928 240.812 172.161 235.572 172.161 229.108C172.161 222.644 166.928 217.404 160.472 217.404Z"
        fill="#E6E8E9"
      />
      <path
        d="M245.335 238.983H183.972C182.358 238.983 181.05 237.673 181.05 236.057C181.05 234.441 182.358 233.131 183.972 233.131H245.335C246.948 233.131 248.257 234.441 248.257 236.057C248.257 237.673 246.948 238.983 245.335 238.983Z"
        fill="#E6E8E9"
      />
      <path
        d="M203.331 226.548H183.972C182.358 226.548 181.05 225.238 181.05 223.622C181.05 222.006 182.358 220.696 183.972 220.696H203.331C204.944 220.696 206.253 222.006 206.253 223.622C206.253 225.238 204.944 226.548 203.331 226.548Z"
        fill="#E6E8E9"
      />
      <path
        d="M269.014 159.248H128.027C124.7 159.244 122.004 156.545 122 153.213V107.859C122.004 104.528 124.7 101.828 128.027 101.824H269.014C272.341 101.828 275.037 104.528 275.041 107.859V153.213C275.037 156.545 272.341 159.244 269.014 159.248Z"
        fill="#2969F2"
      />
      <path
        d="M160.472 118.832C154.017 118.832 148.784 124.072 148.784 130.536C148.784 137 154.017 142.241 160.472 142.241H160.472C166.928 142.241 172.161 137 172.161 130.536C172.161 124.072 166.928 118.832 160.472 118.832Z"
        fill="white"
      />
      <path
        d="M245.335 140.412H183.972C182.358 140.412 181.05 139.102 181.05 137.486C181.05 135.87 182.358 134.56 183.972 134.56H245.335C246.948 134.56 248.257 135.87 248.257 137.486C248.257 139.102 246.948 140.412 245.335 140.412Z"
        fill="white"
      />
      <path
        d="M203.331 127.976H183.972C182.358 127.976 181.05 126.666 181.05 125.05C181.05 123.434 182.358 122.124 183.972 122.124H203.331C204.944 122.124 206.253 123.434 206.253 125.05C206.253 126.666 204.944 127.976 203.331 127.976Z"
        fill="white"
      />
      <path
        d="M159.363 135.397C159.056 135.397 158.756 135.298 158.51 135.113L158.495 135.101L155.28 132.639C154.655 132.158 154.537 131.261 155.017 130.634C155.497 130.008 156.392 129.889 157.019 130.369L159.1 131.968L164.02 125.54C164.251 125.239 164.591 125.042 164.966 124.993C165.342 124.943 165.721 125.045 166.022 125.276L166.022 125.276L165.992 125.318L166.023 125.276C166.648 125.757 166.766 126.654 166.287 127.281L160.501 134.837C160.229 135.19 159.809 135.396 159.365 135.395L159.363 135.397Z"
        fill="#2969F2"
      />
      <path
        d="M357.054 278.43H217.893C217.691 278.43 217.527 278.266 217.527 278.064C217.527 277.862 217.691 277.698 217.893 277.698H357.054C357.256 277.698 357.419 277.862 357.419 278.064C357.419 278.266 357.256 278.43 357.054 278.43Z"
        fill="#D2D5D7"
      />
      <path
        d="M305.012 192.013C305.075 190.675 305.727 189.433 306.793 188.622C307.858 187.811 309.228 187.515 310.532 187.812L316.512 179.373L322.52 181.762L313.908 193.56C313.249 195.771 311.043 197.138 308.774 196.744C306.504 196.349 304.888 194.317 305.012 192.013L305.012 192.013Z"
        fill="#A0616A"
      />
      <path
        d="M311.572 184.756L322.204 166.849L317.872 155.282L323.772 139.527L323.989 139.621C324.132 139.682 327.484 141.18 327.981 146.544L334.761 167.881L316.666 191.388L311.572 184.756Z"
        fill="#040B2B"
      />
      <path
        d="M253.828 118.926C255.156 119.092 256.341 119.84 257.066 120.966C257.791 122.093 257.981 123.483 257.583 124.762L265.523 131.385L262.681 137.199L251.6 127.688C249.45 126.859 248.259 124.551 248.827 122.316C249.395 120.08 251.544 118.624 253.828 118.926Z"
        fill="#A0616A"
      />
      <path
        d="M260.546 126.036L277.552 138.036L289.404 134.605L304.634 141.714L304.524 141.924C304.452 142.061 302.701 145.292 297.322 145.374L275.554 150.493L253.549 130.61L260.546 126.036Z"
        fill="#040B2B"
      />
      <path
        d="M291.664 271.955H285.752L282.94 249.119L291.666 249.12L291.664 271.955Z"
        fill="#A0616A"
      />
      <path
        d="M279.788 270.263H292.931V277.452H274.35V275.708C274.35 272.701 276.785 270.263 279.788 270.263Z"
        fill="#0F2658"
      />
      <path
        d="M315.294 271.955H309.382L306.57 249.119L315.295 249.12L315.294 271.955Z"
        fill="#A0616A"
      />
      <path
        d="M303.418 270.263H316.561V277.452H297.98V275.708C297.98 272.701 300.414 270.263 303.418 270.263Z"
        fill="#0F2658"
      />
      <path
        d="M317.397 188.603L316.915 222.406L316.433 266.834L305.823 265.868L300.519 204.539L293.767 265.868H282.814L281.711 204.056L285.569 190.534L317.397 188.603Z"
        fill="#0F2658"
      />
      <path
        d="M284.512 190.74L282.895 190.67L290.403 149.256L287.329 136.739C286.998 135.391 287.727 134.008 289.024 133.521L294.555 131.444L296.509 126.063L311.925 127.727L312.304 131.932C313.974 132.468 327.731 137.056 326.782 142.284C325.845 147.443 320.314 163.676 320.033 164.499L319.064 187.779L318.945 187.839C318.801 187.911 308.176 193.143 296.632 193.142C292.567 193.142 288.386 192.492 284.512 190.74Z"
        fill="#040B2B"
      />
      <ellipse
        cx="303.613"
        cy="112.286"
        rx="11.1114"
        ry="11.1031"
        transform="rotate(-61.3368 303.613 112.286)"
        fill="#A0616A"
      />
      <path
        d="M312.603 123.045C310.488 125.301 306.56 124.09 306.284 121.008C306.262 120.768 306.264 120.527 306.289 120.288C306.431 118.923 307.219 117.683 307.03 116.242C306.987 115.883 306.854 115.541 306.642 115.248C304.956 112.988 301 116.259 299.409 114.213C298.433 112.958 299.58 110.983 298.831 109.58C297.843 107.73 294.917 108.643 293.082 107.629C291.04 106.501 291.162 103.364 292.506 101.456C294.145 99.129 297.019 97.8873 299.857 97.7083C302.696 97.5294 305.514 98.2977 308.164 99.3317C311.174 100.507 314.16 102.13 316.012 104.781C318.265 108.005 318.482 112.339 317.355 116.108C316.67 118.401 314.331 121.202 312.603 123.045Z"
        fill="#202528"
      />
    </svg>
  );
});

SelectCustomerIllustration.displayName = 'SelectCustomerIllustration';

export { SelectCustomerIllustration };
